import styled from "styled-components";
import { colorPrimary, colorSecondary, hex2rgba } from "../../colors";
import { BreakPoints, ContentWidths } from "../../constants";

export const StyledFeatureList = styled.section.attrs({
  className: "feature-list__container"
})`
  display: flex;
  width: 100%;
  color: ${colorSecondary};
  justify-content: center;

  .feature-list {
    display: flex;
    flex-direction: column;
    margin: 15px;

    @media (min-width: ${BreakPoints.sm}) {
      width: ${ContentWidths.sm};
    }

    @media (min-width: ${BreakPoints.md}) {
      margin: 0;
      width: ${ContentWidths.md};
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: flex-start;
    }

    @media (min-width: ${BreakPoints.lg}) {
      width: ${ContentWidths.lg};
    }

    @media (min-width: ${BreakPoints.xl}) {
      width: ${ContentWidths.xl};
    }

    .fl-text {

      @media (min-width: ${BreakPoints.md}) {
        width: 240px;
      }

      @media (min-width: ${BreakPoints.lg}) {
        width: 320px;
      }

      @media (min-width: ${BreakPoints.xl}) {
        width: 380px;
      }
  
      &__title {
        font-family: Kapra Neue Pro;
        text-transform: uppercase;
        font-size: 3rem;
        font-weight: normal;
        margin: 0 8px 48px 8px;
        padding-top: 4px;
      }
  
      &__features {
        padding: 0;
        margin: 0 0 16px 0;
      }
  
      &__feature {
        font-family: Pitch Sans Medium;
        font-size: 0.8125rem;
        list-style-type: none;
        margin: 0;
        padding: 12px;
        color: ${hex2rgba(colorSecondary, 0.6)};
        cursor: pointer;
        transition: all .2s ease-in-out;

        &:hover,
        &:active {
          box-shadow: inset 0 0 0 4px ${colorPrimary};
          transition: all .2s ease-in-out;
        }
  
        &--active {
          background-color: ${colorPrimary};
          color: ${colorSecondary};
        }
      }
    }
  
    .fl-img {
      width: 100%;
      max-height: 500px;
      object-fit: contain;
  
      &--inactive {
        display: none;
      }
  
      @media (min-width: ${BreakPoints.md}) {
        max-width: 450px;
        padding: 0 15px;
        height: auto;
      }

      @media (min-width: ${BreakPoints.lg}) {
        max-width: 610px;
      }

      @media (min-width: ${BreakPoints.xl}) {
        max-width: 730px;
      }
    }
  }


`